import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class CliLoader extends Loader {}

export const cliLoader = new CliLoader({
  service: SERVICES.client
})
